import * as utils from "../../utils/misc.js";
import * as string from "../../utils/strings.js";
import * as time from "../../utils/time.js";
import { TCHA } from "./class-tcha.js";

export function calculateEntryEnd(entry, nextEntry, x, logObj) {
  // console.trace()
  let end;
  let entryDates = logObj.fullLogAsc;
  let currentEntryDate = time.dateNoTime(new Date(entryDates[x][0]));
  let today = time.dateNoTime(window.viewQuery.today);

  let runTest = false;
  let testTag = "ktt";
  let testStartTime = "21:34";

  // [] if its a mood, energy, or clarity tag, just default to duration of undefined, or 0, or what,

  // abort if...
  if (
    entry.tags.length == 1 &&
    (entry.tags.some((tag) => window.fm.mood.includes(tag)) ||
      entry.tags.some((tag) => window.fm.energy.includes(tag)) ||
      entry.tags.some((tag) => window.fm.clarity.includes(tag)))
  ) {
    entry.end = undefined;
    return;
  }

  // START FUNCTION TO SEE WHICH ENTRY-END TIME TO USE:
  testMessage(testTag, testStartTime, `The entry: ${currentEntryDate}`, entry, runTest, x);

  // 1.
  // If there is a defined end time, use that
  if (entry.end) {
    end = entry.end;
    return;
  }

  // 2.
  // If there isn't an end-time, the start of the nextEntry is the end time...
  else if (nextEntry) {
    testMessage(testTag, testStartTime, `Using time of nextEntry...`, nextEntry, runTest);

    // 2.1
    // ...but if this nextEntry is a solo-mood /energy /clarity tag, skip it
    // and loop until we find the next one that isn't a solo-mood, and use that
    if (
      nextEntry.tags.length == 1 &&
      (nextEntry.tags.some((tag) => window.fm.mood.includes(tag)) ||
        nextEntry.tags.some((tag) => window.fm.energy.includes(tag)) ||
        nextEntry.tags.some((tag) => window.fm.clarity.includes(tag)))
    ) {
      testMessage(
        testTag,
        testStartTime,
        `We're skipping cos next one is a mood tag... see below:`,
        nextEntry,
        runTest,
      );

      // 2.1.1
      // Now we need to check that the next entry is usable.
      // if not, keep looping until we find one that is usable.
      // start looping at the one after thisEntry
      let entries = Object.entries(logObj.fullLog)[x][1].entries;
      let thisEntryIndex = entries.indexOf(entry);
      for (let y = thisEntryIndex + 1; y < entries.length; y++) {
        // if its a mood tag, skip
        if (entries[y].tags.length == 1 && entries[y].tags.some((tag) => window.fm.mood.includes(tag))) {
          testMessage(testTag, testStartTime, `This is a skippable mood tag:`, entries[y], runTest);
          continue;
        }

        // if the next tag is a candidate:
        // has a start time and isn't a solo-mood tag
        else if (
          entries[y].tags.length > 0 &&
          entries[y].start &&
          entries[y].tags.some((tag) => !window.fm.mood.includes(tag))
        ) {
          testMessage(testTag, testStartTime, `This is our candidate:`, entries[y], runTest);

          // now that we have our candidate, we must make sure its not a future entry
          // so we take the smaller value:
          //  current time, or the start of the next entry.

          entry.end = entries[y].start; // format: [string] 00:00

          // let timeNow = xyz_time_to_HHMM_string( new Date() )
          // entry.end = time.dateStringToJS(timeNow) <= time.dateStringToJS(entries[y].start) ?
          //     timeNow : entries[y].start
          // console.log(time.dateStringToJS(entries[y].start))

          return;

          // Else we found no candidate, so...
        } else {
          continue;
        }
      } // end looping through the entries
    }

    // cos the next tag isnt a solo one.... but why does it think there is a next entry?

    // 2.2
    // ... but if the next one isn't a solo-mood tag, use it's ending instead
    else {
      testMessage(testTag, testStartTime, `nextEntry is a good candidate.. using it: ${entry}.`, entry, runTest);
      entry.end = nextEntry.start;
      return;
    }
  }

  // 3.
  // So there is no nextEntry...
  testMessage(testTag, testStartTime, `No nextEntry as a viable candidate... check for today`, entry, runTest);
  // 3.1
  // check if we are on today. if we are, use now's time.
  if (
    currentEntryDate.getTime() == today.getTime() || // today
    currentEntryDate.getTime() == time.setToTomorrow(today).getTime() // yesterday
  ) {
    // console.log('TODAY')
    testMessage(testTag, testStartTime, `On today, use now() time...`, entry, runTest);
    // if we are passed midnight
    // instead of checking for "Today"
    // we need to check for tomorrow, or today+1

    // get today's time to check if the hour is after midnight
    // then, check if entryDates[x] matches window.viewQuery.today+1
    // isAfterMidnight(new Date(window.viewQuery.today)

    let now = new Date();
    // console.log(now)

    let nowH = String(now.getHours()).padStart(2, "0");
    let nowM = String(now.getMinutes()).padStart(2, "0");
    end = `${nowH}:${nowM}`;
    entry.end = end;

    // 3.2
    // it's not today either, so just set the duration off
    // and notify in the app's frontend notification screen
  } else {
    // console.log(new Date(window.viewQuery.today).getDate()+1)
    // console.log(window.viewQuery.today)
    // console.log( new Date( new Date().setDate( new Date(window.viewQuery.today).getDate()-1) ))
    // if (entry.start == '00:04') {
    //   console.log(entry)
    //   console.log(window.viewQuery.today)
    //   console.log(entryDates[x])
    //   }
    testMessage(testTag, testStartTime, `It's not today either...`, nextEntry, runTest);
    entry.end = entry.start;

    // [] this needs to check if the entry is one of today's or yesterday's instead of checking for runTest criteria
    if (runTest && entry.tags.includes(testTag) && entry.start == testStartTime) {
      // notify('This entry has no ending: ', entry)
    }
  }
}

function testMessage(testTag, testStartTime, message, obj, runTest, _obj2, _obj3) {
  if (runTest == true) {
    // console.trace()

    // test conditions:
    if (obj && obj.tags.includes(testTag) && obj.start == testStartTime) {
      console.log(testTag);
      console.log(obj.tags);
      console.log(`(${testTag}) - ${message}`);
      console.log("=======");
    }
  }
}

export function calculateEntryDuration(entry, day) {
  if (
    (entry.tags.some((r) => window.fm.mood.includes(r)) && entry.tags.length == 1) ||
    (entry.tags.some((r) => window.fm.energy.includes(r)) && entry.tags.length == 1) ||
    (entry.tags.some((r) => window.fm.clarity.includes(r)) && entry.tags.length == 1) ||
    entry.tags.some((r) => window.fm.cycles.includes(r))
  ) {
    entry.duration = 0;
  } else if (entry.duration) {
    return;
  } else {
    entry.duration = calculateDuration(entry.start, entry.end);
    // warning incase a duration is negative
    if (entry.duration < 0) {
      console.warn(`negative duration! ${entry.duration}!`);
      console.warn("day", day);
      console.warn(entry);

      notify(`negative duration! ${entry.duration}!`, { day: day.date.full_date, entry });

      // print into a notify box the relevant info so it can be fixed by the user.
    }
  }
}

export function calculateDuration(start = "00:00", end = "00:00") {
  // each parameter is a string in 00:00 format
  if (start == 0) {
    start = "00:00";
  } //console.log('start 00:00')}
  if (end == 0) {
    end = "00:00";
  } //console.log('end   00:00')}

  let startHM = start.match(window.regExes.splitTime);
  let endHM = end.match(window.regExes.splitTime);
  let totalMins, totalHours, duration;

  // compare start hour
  // if they are the same hour, calculate the difference between the mins
  if (endHM != null) {
    // adjust calculation for entries starting at or after midnight
    if (endHM[0] < window.config.settings.dayStartTime) {
      endHM[0] = +endHM[0] + +24;
    }
    if (startHM[0] < window.config.settings.dayStartTime) {
      startHM[0] = +startHM[0] + +24;
    }

    if (startHM[0] == endHM[0]) {
      totalMins = ++endHM[1] - ++startHM[1];
      duration = totalMins;
    } else {
      totalMins = endHM[1] - startHM[1];
      totalHours = endHM[0] - startHM[0];
      duration = totalHours * 60 + totalMins;
    }
  }
  return duration; // a single number, the total minutes
}

export function parseEntryHabits(entry, eachDay, _date) {
  // grab its tags
  let tag = entry.tags[0];
  if (tag === "" || undefined) {
    return;
  }

  // make sure its a tag thats in window.fm.categories. abort if it isnt.
  // if it is, just get the first tag.
  Object.values(window.fm.categories).forEach((categoryTags) => {
    // console.log(categoryTags)
    categoryTags.forEach((tagObj) => {
      // console.log(tagObj.name)
      if (tagObj.name != tag) {
        return;
      } else {
        // console.log('hi')
        // only show today
        // if (!time.is_this_date_today()) {return}

        // if its a new habit
        if (!eachDay.habits[tagObj.name]) {
          eachDay.habits[tagObj.name] = {
            data: [],
            summary: {},
          };
        }
        eachDay.habits[tagObj.name].data.push(makeHabitObj(entry));
      }
      eachDay.habits[tagObj.name].summary = summariseDailyHabitData(eachDay, tagObj);
      // console.log(eachDay.habits)
    });

    // console.log(eachDay.habits[tag])
  });

  // add that object to the day's habit key.
}

export function calculateEntrySummary(eachDay) {
  let summary = {};
  let _totalCounter = 0;
  // calculate Entry Meta: a summary object to the start of each Entry Date.
  // summary = { tag1: 30, tag2: 45, etc }

  for (let a = 0; a < eachDay.length; a++) {
    let entry = eachDay[a];

    if (entry.tags != undefined) {
      // entry.tags = ["sit", "exercise", "code"]

      // loop through list of tags
      // increment the duration for each one
      for (let x = 0; x < entry.tags.length; x++) {
        let tagName = entry.tags[x];
        if (summary[tagName] == undefined) {
          summary[tagName] = [];
          summary[tagName].push(entry.duration);
          _totalCounter += +entry.duration;
        } else {
          summary[tagName].push(entry.duration);
          _totalCounter += +entry.duration;
        }
      }
    }
  }
  return summary;
}

function makeHabitObj(entry) {
  // console.log('makeHabitObj ', entry)
  const entryComment = entry.comment.trim(); // remove leading / trailing whitespace
  const JSONObj = makeJSONObj(entryComment);
  // console.log(JSONObj)

  const habitObj = {
    start: entry.start || undefined,
    end: entry.end || undefined,
    data: JSONObj,
    mood: entry.rhythm.mood,
    clarity: entry.rhythm.clarity,
    energy: entry.rhythm.energy,
  };
  return habitObj;
}

function makeJSONObj(comment, jsonObj = "") {
  // parse JSON object
  const jsonStringWithQuotes = string.makeJSONString(comment);
  try {
    jsonObj = JSON.parse(jsonStringWithQuotes.quoted);
    // wrap all stray number values in an array for consistent data manipulation later...
    // Object.values(jsonObj).map(val => { if (typeof(val) === 'number') { return val = 0 } })
  } catch (error) {
    console.warn("---start error");
    console.warn(error);
    console.warn(jsonStringWithQuotes.quoted);
    notify("makeJSONObj error", {
      error: JSON.stringify(error.message, Object.getOwnPropertyNames(error)),
      obj: jsonStringWithQuotes.string,
    });
  }

  return jsonObj;
}

function summariseDailyHabitData(day, tagObj, _keys = {}) {
  // go through all the keys and values for the day
  // list out one of each key
  // if (!time.is_this_date_today(day[0])) {return}

  const habitsArray = day.habits[tagObj.name].data;

  if (habitsArray == undefined) return "";

  if ("kb" in day.habits) {
    // || 'bodyweight' in day.habits) {

    // console.error(`⚡️ === Start ${tagObj.name} habit`)

    let count = 0;

    habitsArray.forEach((habit) => {
      for (let key in habit.data) {
        if (habit.data.hasOwnProperty(key)) {
          count += 1;
          // console.info(`Habit [${count}]: ${JSON.stringify(key)}, Pass in just this: ${JSON.stringify(habit.data[key])}`)
          habit.data[key] = countHabitTotals(habit.data[key]);
          // console.info(`🌈 New Habit: ${JSON.stringify(habit.data)}`)
          //
        }
      }
    });

    // console.error('------------')
    // console.info('KEYS !')
    // console.log(habitsArray[0].data)
    return habitsArray[0].data;
  }
}

export function countHabitTotals(habitData, new_keys = {}) {
  // console.error('habitData =========')
  // console.error(habitData)
  if (habitData == undefined) return;

  // console.info(`🔄 countHabitTotals:`)

  for (let data in habitData) {
    if (habitData.hasOwnProperty(data)) {
      // if its a Number, convert to array
      if (Object.prototype.toString.call(habitData[data]) === "[object Number]") {
        habitData[data] = Array.of(habitData[data]);
      }

      // console.info(`data type: ${Object.prototype.toString.call(habitData[data])}`)
      // console.info(`data key: ${JSON.stringify(data)}`)
      // console.info(`data: ${JSON.stringify(habitData[data])}`)

      // if its an Array, compute and return the 4 key-vals.
      if (Object.prototype.toString.call(habitData[data]) === "[object Array]") {
        // console.error('is Array')

        const keys = new TCHA();

        // count
        keys.count += habitData[data].length;

        habitData[data].forEach((value) => {
          // TOTAL
          keys.total += value;
          // HIGHEST
          keys.highest = Math.max(keys.highest, value);
          // AVG
          keys.avg = parseInt(keys.total / keys.count);
        });

        // console.info(`🐈  formatted Keys: ${JSON.stringify(keys)}`)

        new_keys[data] = keys;
      } else {
        // console.error('is not Array =========  ========= =========')

        new_keys = habitData;
        // new_keys = aggregateDailySummariesIntoWeeklyMonthly(habitData)
      }
    }
  }
  // console.error(new_keys)

  return new_keys;
}

function notify(message, obj) {
  // document.getElementById('notify').innerHTML = "";

  document.querySelector("#notify div#notices").insertAdjacentHTML(
    "beforeend",
    `
    <div class="notify-msg">
      <p class="message">${message}</p>
      <p class="obj">${JSON.stringify(obj, null, 2)}</p><br/>
    </div>
    `,
  );
}
